// eslint-disable-next-line import/no-anonymous-default-export
export default {
  riskAssociatedqn: "Are there risks associated with PMS investments?",
  risk: "Yes. All investments involve a certain amount of risk, including the possible erosion of the principal amount invested, which varies depending on the security selected. The client must read all the risk factors disclosed in the Disclosure Document before investing.",
  coreBelief: "Core Belief ",
  coreBeliefsubheading: " “Companies create wealth, not markets”",
  beliefText:
    "Our aim is to identify Prominent Businesses, with Competent Management, at Reasonable Valuations",
  team: "An Experienced Team",
  standFor: "What Do We Stand For?",
};
export const InvestorCorner = {
  Investor_Corner_Title: "Investor Corner",
  Presentation: "Presentations",
  Factsheets: "Factsheets",
  Forms: "Forms",
  Regulatory_Disclosures: "Regulatory Disclosures",
  AIF_Disclosure:"AIF Disclosure",
  Disclosure_Document: "Disclosure Document",
  FAQ: `FAQ`,
  Investors_Faq: `Investors FAQ`,
  Grievance_Disclosure: "Grievance Disclosure",
  Frequently_Questions:
    "Some frequently asked questions and queries that you as an Investor might have.",
  Download: "Download",
  Download_Presentation: "Download the right presentations for your needs",
  Download_Factsheets: "Download the right factsheets for your needs",
  Download_Forms: "Download the right forms for your needs",
  Download_Disclosure: "Download the right document for your needs",
  Investor_Grievance_subtitle:
    "Disclosure of Investor Grievance Redressal - PMS",
  Alternate_Dispute_Resolution_Circular:
    " Alternate Dispute Resolution Circular ",
  Link_for_login_to_ODR: "Link for login to ODR",
  SOP_Version: "SOP V1.2.1",
  SOP_SUB_TITLE: "Common SOP for Centralized Demise Information",
};

export const StrategyFeatureData =
  "<p>*The strategy and portfolio composition described herein involves risk and there can be no assurance that specific objectives will be met under differing market conditions or cycles. The investment strategy and the composition of the strategy as stated herein is only indicative in nature and is subject to change within the provisions of the disclosure document and client agreement. Please refer to the disclosure document &amp; client agreement for details and risk factors.</p> <p>*The Portfolio Manager reserves the right to change the Benchmark of the strategy at its discretion. The composition of the Portfolio may or may not be the same as that with the composition of the Benchmark. The details pertaining to the investment approach mentioned herein is a subset of details specified in the Disclosure Document. Kindly refer the Disclosure Document for the detailed investment approach including strategy specific risk factors before investing.</p>";

export const CIN_NUMBER = "U99999DL1993PLC054135";
export const EMAIL_PLACEHOLDER = "email@address.com";
export const TOAST_COMMON_SUCCESS = "Success";
export const TOAST_COMMON_ERROR = "Error";
export const TOAST_SUBSCRIBE_EMAIL = "You've subscribed successfully";
export const TOAST_COMMON_OTP_SUCCESS = "OTP Verified";
export const TOAST_COMMON_API_ERROR = "Something went wrong";
export const ENTER_VALID_NAME = "Enter valid name";
export const ENTER_VALID_EMAIL = "Enter valid email";
export const ENTER_VALID_CONTACT_NUMBER = "Enter valid contact number";
export const ENTER_VALID_OTP = "Enter valid OTP";
export const OTP_SENT_SUCCESSFULLY = "OTP sent successfully";
export const encryptDecryptKey = "eckqI";
